import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import './styles.less';
import { FormTextAreaField } from '../../../../../semantic-ui/components/form-textarea-field';
import { CustomLoader } from '../../../../../components/custom-loader';

export const ProductInvoiceFormView = ({ isLoading }) => {
	if (isLoading) {
		return <CustomLoader />;
	}

	return (
		<>
			<div className="product-invoice-form">
				<Grid className="product-invoice-form__content">
					<Grid.Row className="product-invoice-form__content-row">
						<Grid.Column width={15} className="product-invoice-form__content-column">
							Товарная накладная
							<div className="product-invoice-form__content-column-field">
								<Field
									name="product_invoice"
									type="text"
									component={FormTextAreaField}
									autoComplete="off"
									width="100%"
									height="100%"
									resize="vertical"
									rows={6}
									placeholder="Укажите номер товарной накладной"
								/>
							</div>
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</div>
		</>
	);
};

ProductInvoiceFormView.propTypes = {
	isLoading: PropTypes.bool.isRequired,
};
